import React from "react";
import { Check } from "lucide-react";
import UserAvatar from "../Discussion/atoms/UserAvatar";
import { INK_2, BURGUNDY, BURGUNDY_TINT, LINE } from "../Bureau/bureauTokens";

function lastMessagePreview(lastMessage) {
  if (!lastMessage) return "Nouveau message";
  if (lastMessage.body) return lastMessage.body;
  if (lastMessage.attachmentType?.startsWith("image/")) return "📎 Image";
  if (lastMessage.attachmentUrl) return "📎 Fichier";
  return "";
}

function DiscussionNotifRow({ otherUser, lastMessage, unreadCount, onOpen, onMarkRead, marking }) {
  const name = otherUser ? `${otherUser.name || ""} ${otherUser.lastName || ""}`.trim() : "Collaborateur";

  return (
    <div
      className="flex items-center gap-2.5 px-3 py-2.5"
      style={{ borderRadius: 10, borderBottom: `1px solid ${LINE}` }}
    >
      <button onClick={onOpen} className="flex-1 min-w-0 flex items-center gap-2.5 text-left">
        <UserAvatar name={otherUser?.name} lastName={otherUser?.lastName} picture={otherUser?.picture} size={36} />
        <span className="flex-1 min-w-0 flex flex-col gap-0.5">
          <span className="flex items-center justify-between gap-2">
            <span className="text-[12px] truncate" style={{ color: BURGUNDY, fontWeight: 700 }}>
              {name}
            </span>
            <span
              className="flex-shrink-0 flex items-center justify-center text-[10px] font-bold text-white"
              style={{ minWidth: 18, height: 18, borderRadius: 999, background: BURGUNDY, padding: "0 5px" }}
            >
              {unreadCount}
            </span>
          </span>
          <span className="text-[11px] truncate" style={{ color: INK_2 }}>
            {lastMessagePreview(lastMessage)}
          </span>
        </span>
      </button>
      <button
        onClick={onMarkRead}
        disabled={marking}
        title="Marquer comme lu"
        className="flex-shrink-0 flex items-center justify-center disabled:opacity-50"
        style={{ width: 28, height: 28, borderRadius: "50%", background: BURGUNDY_TINT, color: BURGUNDY }}
      >
        <Check size={13} />
      </button>
    </div>
  );
}

export default DiscussionNotifRow;
